import { gql, TypedDocumentNode } from '@apollo/client';
import { Return, RETURN_FRAGMENT } from '../useReturn/return.rest';
import { OrderItem, ORDER_ITEM_FRAGMENT } from '../useOrder/order.rest';

export type GetReturnsQueryVariables = {
  countryCode: string;
  pageNumber: number;
};

export type GetReturnsQuery = {
  getReturns: {
    __typename: 'RestReturns';
    data: Return[];
    included: OrderItem[];
    meta: {
      pagination: {
        __typename: 'RestReturnsMetaPagination';
        totalPages: number;
        currentPage: number;
        previousPage: number | null;
        nextPage: number | null;
        perPage: number;
        totalEntries: number;
      };
    };
  };
};

const RETURNS_META_FRAGMENT = gql`
  fragment ReturnsMetaFragment on RestReturnsMeta {
    pagination @type(name: "RestReturnsMetaPagination") {
      totalPages: total_pages
      currentPage: current_page
      previousPage: previous_page
      totalEntries: total_entries
      nextPage: next_page
      perPage: per_page
    }
  }
`;

export const GET_RETURNS_QUERY: TypedDocumentNode<GetReturnsQuery, GetReturnsQueryVariables> = gql`
  query GetReturnsQuery($countryCode: String!, $pageNumber: Int!) {
    getReturns(countryCode: $countryCode, pageNumber: $pageNumber)
      @rest(
        type: "RestReturns"
        endpoint: "shipments"
        path: "/v3.5/shipments?include=return_order_items&shipment_type=RETURN&country_code={args.countryCode}&page[number]={args.pageNumber}"
      ) {
      data @type(name: "RestReturn") {
        ...ReturnFragment
      }
      included @type(name: "RestOrderItem") {
        ...OrderItemFragment
      }
      meta @type(name: "RestReturnsMeta") {
        ...ReturnsMetaFragment
      }
    }
  }
  ${RETURN_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
  ${RETURNS_META_FRAGMENT}
`;
